// material-ui
import { useTheme } from '@mui/material/styles';

import logo from 'assets/images/logo.svg';

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme();

    return <img src={logo} alt="Fineart" width="180" />;
};

export default Logo;
